/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { resetAddUserSlice } from "../../redux/Slice/Users/AddUserSlice";
import { resetDeleteSlice } from "../../redux/Slice/Users/DeleteUserSlice";
import { resetUpadateSlice } from "../../redux/Slice/Users/UpdateUserSlice";
import { AllUsersList } from "../../redux/Slice/Users/UserListSlice";
import { ArchiveUser } from "./ArchiveUser";



const ListOfUsers: React.FC = () => {

  const dispatch = useAppDispatch();
  const { AllUserList } = useAppSelector(state => state.allUsers)
  const { UserRole, canViewSensitiveData, canDeleteSensitiveData } = useAppSelector(state => state.verifiedUser)
  const navigate = useNavigate()
  const [archive, setArchive] = useState(false);
  const [deleteId, setDeleteId] = useState("")

  const isSuperAdminRestricted = UserRole?.role?.name === "SUPER_ADMIN" && !canViewSensitiveData;
  const isSuperAdminDeleteRestricted = UserRole?.role?.name === "SUPER_ADMIN" && !canDeleteSensitiveData;

  const columns = React.useMemo(
    () => [
      {
        Header: 'User Name',
        accessor: "fullName",
      },
      {
        Header: 'Role',
        accessor: 'role',
      },
      {
        Header: 'Mobile Number',
        accessor: 'phone',
      },
      {
        Header: 'Email Address',
        accessor: 'email',
      },
      {
        Header: 'Aadhar Number',
        accessor: 'aadharNumber',
      },
      {
        Header: 'Status',
        accessor: 'isActive',
      },
    ],
    []
  )

  useEffect(() => {
    dispatch(AllUsersList());
    dispatch(resetAddUserSlice());
    dispatch(resetUpadateSlice())
    dispatch(resetDeleteSlice());

  }, []);

  const handleAdd = () => {
    navigate("/add-user")
  }

  const handleEdit = (id: string) => {
    navigate("/update-user", { state: id })
  }

  const handleUserInfo = (id: string) => {
    navigate("/user-info", { state: id })
  }
  const HandleDelete = (id: string) => {
    setArchive(true)
    setDeleteId(id)
  }
  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title d-flex flex-wrap align-items-center justify-content-between gap-2">
            <Card.Title className="mb-0">List Of Users</Card.Title>
            </div>
          <div className="d-flex justify-content-end my-2">
            <ButtonGroup>
              <Button onClick={handleAdd} type="button" bname="Add User" name="AddUser" id="AddUserButton" className="btn btn-primary rounded-1" />
            </ButtonGroup>
          </div>
        </Card.Body>
        <div className="table-responsive">
          <Table columns={columns} data={AllUserList} handleEdit={handleEdit} HandleShow={handleUserInfo} HandleDelete={HandleDelete} hideEditAction={isSuperAdminRestricted} hideDeleteAction={isSuperAdminDeleteRestricted} />
        </div>
        <ArchiveUser setArchive={setArchive} archive={archive} id={deleteId} />
      </Card>
    </>
  );
};

export { ListOfUsers };
